import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const BagIconSmall: React.FC<IconProps> = (props) => (
  <IconWrapper size="small" {...props}>
    <path
      fillRule="evenodd"
      d="M8 0c-.8 0-1.536.312-2.074.76C5.4 1.2 5 1.83 5 2.5V5H1.337A.336.336 0 0 0 1 5.335v8.923c0 .648.465 1.202 1.103 1.313 1.631.287 4.263.43 5.894.43 1.632 0 4.265-.143 5.9-.43A1.333 1.333 0 0 0 15 14.257V5.334a.335.335 0 0 0-.335-.333H11V2.5c0-.68-.395-1.31-.925-1.75A3.281 3.281 0 0 0 8 0Zm2 6v1.5a.5.5 0 0 0 1 0V6h3v8.257c0 .162-.116.3-.276.328-1.554.273-4.123.415-5.727.415-1.603 0-4.17-.142-5.721-.414A.333.333 0 0 1 2 14.257V6.001h3V7.5a.5.5 0 0 0 1 0V6h4Zm0-1V2.5c0-.292-.181-.663-.564-.98A2.281 2.281 0 0 0 8 1c-.543 0-1.057.214-1.433.528C6.18 1.851 6 2.223 6 2.5V5h4Z"
    />
  </IconWrapper>
)

export default BagIconSmall
